/**
 * 인증 상태 (프론트엔드 내부 상태)
 */
export enum AuthStatus {
  IDLE = "IDLE", // 초기 상태
  AUTHENTICATING = "AUTHENTICATING", // 인증 중
  AUTHENTICATED = "AUTHENTICATED", // 인증됨
  UNAUTHENTICATED = "UNAUTHENTICATED", // 미인증
  TOKEN_EXPIRED = "TOKEN_EXPIRED", // 토큰 만료
  REFRESHING = "REFRESHING", // 토큰 갱신 중
}

/**
 * 토큰 타입
 */
export enum TokenType {
  ACCESS = "ACCESS",
  REFRESH = "REFRESH",
}

/**
 * Storage 키 상수
 */
export const STORAGE_KEYS = {
  ACCESS_TOKEN: "access-token",
  REFRESH_TOKEN: "refresh-token",
  // 레거시 키 (마이그레이션용)
  LEGACY_ACCESS_TOKEN: "x-auth-token",
} as const;

/**
 * 토큰 만료 관련 상수
 */
export const TOKEN_CONFIG = {
  ACCESS_TOKEN_BUFFER: 60 * 1000, // 1분 전에 갱신
} as const;

/**
 * 프론트엔드 내부 토큰 정보 타입
 */
export interface TokenInfo {
  accessToken: string;
  refreshToken: string;
  expiresAt: number; // timestamp (ms) - JWT payload.exp에서 추출
}

/**
 * 인증된 사용자 정보 (프론트 관점)
 */
export interface AuthenticatedUser {
  id: string;
  academyId: string;
  relationId: string;
  status: AuthStatus;
}
